import { useFormFields, useMailChimpForm } from "use-mailchimp-form";
import blackLogo from "../../../../assets/images/black-logo.svg";
import {useEffect, useState} from "react";
import styled from "@emotion/styled";



const FormContainer = styled.div`
    width: 100%;
    max-width: 715px;
    padding: 60px 54px 30px 54px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
    @media (max-width: 581px) {
        padding: 50px 21px 30px 21px;
    }
`;

const ContentWrapper = styled.div`
    max-width: 620px;
    margin: 0 auto;
`;

const Logo = styled.div`
    margin-bottom: 40px;
    img {
        height: 32px;
    }
`;


const Subtitle = styled.h4`
    font-family: "Gilroy-SemiBold", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 27px;
    color: #000000;
    margin-bottom: 40px;
`;

const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 24px;
`;

const InputGroup = styled.div`
    display: flex;
    gap: 16px;

    @media (max-width: 576px) {
        flex-direction: column;
    }
`;

const Input = styled.input`
    flex: 1;
    padding: 16px;
    border: none;
    border-bottom: 1px solid #e7e5e5;
    font-family: "Gilroy", sans-serif;
    font-size: 16px;
    color: #010035;

    &::placeholder {
        color: #7c7c7c;
    }

    &:focus {
        outline: none;
        border-color: #010035;
    }
`;

const SubmitButton = styled.button`
    align-self: center;
    padding: 16px 48px;
    margin-left: auto;
    background: #010035;
    color: white;
    border: none;
    border-radius: 100px;
    font-family: "Gilroy-SemiBold", sans-serif;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.2s;
    @media (max-width: 581px) {
        margin: 0 auto;
    }

    &:hover {
        background: #01002b;
    }
`;

const Message = styled.div`
    font-family: "Gilroy", sans-serif;
    font-size: 14px;

    &.error {
        color: #ff4d4f;
    }

    &.success {
        color: #52c41a;
    }

    &.loading {
        color: #7c7c7c;
    }
`;

const FeaturesGrid = styled.div`
    max-width: 1280px;
    padding-left: 20px;
    padding-right: 20px;
    margin: 80px auto 0;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 32px;

    @media (max-width: 992px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 576px) {
        grid-template-columns: 1fr;
    }
`;

const FeatureItem = styled.div`
    color: white;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 18px;
    border-right: 1px solid #e7e5e5;
    height: 100%;
    padding-right: 20px;

    &:last-child {
        padding-right: 0;
        border-right: none;
    }

    @media (max-width: 992px) {
        &:nth-child(2n) {
            border-right: none;
        }
    }


    @media (max-width: 576px) {
        border-right: none;
        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
        padding-top: 20px;
        padding-bottom: 38px;

        &:last-child {
            border-bottom: none;
        }
    }
`;

const FeatureIcon = styled.div`
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 100%;
        height: 100%;
        fill: #ffa800;
    }
`;

const FeatureText = styled.p`
    font-family: "Gilroy", sans-serif;
    font-size: 16px;
    line-height: 1.5;
    color: white;
    margin: 0;
    height: 100%;
    text-align: left;
`;

const WriteMessage = ({  }) => {

    const postUrl = `https://pivothawk.com/step/wp-json/contact-form-7/v1/contact-forms/109/feedback`
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('');

    const { fields, handleFieldChange } = useFormFields({
        EMAIL: "",
        MERGE1: "",
        Subject: "",
        message: "", // ← було messages — заміни!
    });

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError(null);
        setSuccess(false);

        const formData = new FormData();
        formData.append('_wpcf7', '109');
        // formData.append('_wpcf7_version', '6.0.6');
        formData.append('_wpcf7_locale', 'en_US');
        formData.append('_wpcf7_unit_tag', 'wpcf7-f109-p1-o1');
        formData.append('_wpcf7_container_post', '1');


        formData.append('MERGE1', fields.MERGE1);
        formData.append('EMAIL', fields.EMAIL);
        formData.append('Subject', fields.Subject);
        formData.append('message', fields.message);

        try {
            const response = await fetch(postUrl, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (response.ok) {
                setSuccess(true);
                setMessage(data.message || 'Your message has been sent successfully!');
            } else {
                setError(true);
                setMessage(data.message || 'Something went wrong, please try again.');
            }
        } catch (error) {
            setError(true);
            setMessage('Error sending message, please try again later.');
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            <FormContainer>
                <ContentWrapper>

                    <Subtitle>
                        If you have any questions, please leave your details and we will contact you as soon as possible
                    </Subtitle>

                    <Form
                        onSubmit={handleSubmit}
                    >
                        <InputGroup>
                            <Input
                                id="MERGE1"
                                placeholder="Name"
                                type="text"
                                value={fields.MERGE1}
                                onChange={handleFieldChange}
                            />
                            <Input
                                id="EMAIL"
                                placeholder="Email"
                                type="email"
                                value={fields.EMAIL}
                                onChange={handleFieldChange}
                            />
                        </InputGroup>
                        <Input
                            id="Subject"
                            placeholder="Subject"
                            type="text"
                            value={fields.Subject}
                            onChange={handleFieldChange}
                        />
                        <Input
                            id="message"
                            placeholder="Message"
                            type="text"
                            value={fields.message}
                            onChange={handleFieldChange}
                        />


                        <SubmitButton type="submit" disabled={loading}>
                            {loading ? 'Submitting...' : 'Submit'}
                        </SubmitButton>
                    </Form>

                    <Message
                        className={
                            loading
                                ? "loading"
                                : error
                                    ? "error"
                                    : success
                                        ? "success"
                                        : ""
                        }
                    >
                        {loading && "Submitting..."}
                        {error && (message === "0 - Please enter a value"
                            ? "Please enter your email address"
                            : message)}
                        {success && message}
                    </Message>
                </ContentWrapper>
            </FormContainer>
        </>
    );
};


export default WriteMessage;
